// Confetti animation

export function showConfetti() {
    const container = document.createElement('div');
    container.className = 'success-confetti';
    document.body.appendChild(container);

    const colors = ['#1e40af', '#3b82f6', '#0284c7', '#0ea5e9', '#60a5fa'];

    for (let i = 0; i < 50; i++) {
        const confetti = document.createElement('div');
        confetti.className = 'confetti-piece';
        confetti.style.left = Math.random() * 100 + '%';
        confetti.style.background = colors[Math.floor(Math.random() * colors.length)];
        confetti.style.animationDelay = Math.random() * 0.5 + 's';
        container.appendChild(confetti);
    }

    setTimeout(() => container.remove(), 3000);
}
